import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { GatewaySearch } from '@vi-iot/client';

import { getViewportHeight } from '@common';
import { GatewaysState, isNBIoTAndNotRegistered, SearchStore } from '@store';

import { SearchService } from '../../../../+search/search.service';

@Component({
  selector: 'app-gateways-search-results',
  templateUrl: './gateways-search-results.component.html',
  styleUrls: ['./gateways-search-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GatewaysSearchResultsComponent {
  @Output() fetchNext = new EventEmitter();
  @Input() dataState$: Observable<GatewaysState>;
  @Input() searchParams;
  itemSize = 202;
  nextBatch = false;
  getViewportHeight = getViewportHeight;
  isNBIoTAndNotRegistered = isNBIoTAndNotRegistered;

  constructor(
    public searchService: SearchService,
    private searchStore: SearchStore,
    private router: Router
  ) {}

  onFetchNext(next: { limit: number; cursor?: string; offset?: number; searchParams?: any }): void {
    this.searchStore.fetchMoreGateways(this.searchParams, next.limit, next.cursor);
  }

  onNextBatchChange($event: boolean): void {
    this.fetchNext.emit();
    this.nextBatch = $event;
  }

  navigateToInstallations(gateway: GatewaySearch): void {
    if (gateway.registeredAt) {
      const navigationExtras: NavigationExtras = gateway.serial
        ? { state: { searchBreadcrumb: true }, queryParams: { gatewaySerial: gateway.serial } }
        : { state: { searchBreadcrumb: true } };
      this.router.navigate([`/installations/${gateway.installationId}`], navigationExtras);
    }
  }
}
